export default __webpack_public_path__ + "static/rectangle-eff8f76cc589d9fe0c314f8ecdc8bc67.png";